import { createFileRoute } from '@tanstack/react-router';
import { ConfigureProgramsPage } from './ConfigureProgramsPage';

export const Route = createFileRoute('/_protected/admin/users/$userId/configure-programs/')({
  component: ConfigureProgramsPage,
});
